<div class="header">
  <div class="title">
    Filters <span *ngIf="savedFilter && savedFilter.id">({{ savedFilter.name }})</span>
  </div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="filterForm">
  <!-- Subject -->
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3 view-changer">
      <mat-label>Time Period</mat-label>
      <mat-select [formControlName]="'period'">
        <mat-option [value]="'this_week'"> Week to date </mat-option>
        <mat-option [value]="'this_month'"> Month to date </mat-option>
        <mat-option [value]="'last_15_days'"> Past 15 days </mat-option>
        <mat-option [value]="'last_30_days'"> Past 30 days </mat-option>
        <mat-option [value]="'last_60_days'"> Past 60 days </mat-option>
        <mat-option [value]="'last_90_days'"> Past 90 days </mat-option>
        <mat-option [value]="'this_year'"> Year to date </mat-option>
        <mat-option [value]="'all_time'"> All Time </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>View</mat-label>
      <mat-select [formControlName]="'pipelineIdIn'" multiple>
        <mat-option *ngFor="let pipeline of pipelines" [value]="pipeline.id">
          {{ pipeline.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Status</mat-label>
      <mat-select [formControlName]="'projectStageIdIn'" multiple>
        <mat-option *ngFor="let projectStage of projectStages" [value]="projectStage.id">
          {{ projectStage.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Property Type</mat-label>
      <mat-select [formControlName]="'propertyTypeIdIn'" multiple>
        <mat-option *ngFor="let propertyType of propertyTypes" [value]="propertyType.id">
          {{ propertyType.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Deal Type</mat-label>
      <mat-select [formControlName]="'projectTypeIdIn'" multiple>
        <mat-option *ngFor="let projectType of projectTypes" [value]="projectType.id">
          {{ projectType.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Investment Type</mat-label>
      <mat-select [formControlName]="'investmentTypeIdIn'" multiple>
        <mat-option *ngFor="let investmentType of investmentTypes" [value]="investmentType.id">
          {{ investmentType.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Vehicle</mat-label>
      <mat-select [formControlName]="'vehicleIdIn'" multiple>
        <mat-option *ngFor="let vehicle of vehicles" [value]="vehicle.id">
          {{ vehicle.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Assigned To</mat-label>
      <mat-select [formControlName]="'assignedUserIdIn'" multiple>
        <mat-option *ngFor="let user of users" [value]="user.id">
          {{ user.full_name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Body -->
  <div class="actions">
    <div class="formatting"></div>
    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button type="button" (click)="clearAndDiscard()">
        <span>Clear</span>
      </button>
      <!-- Send -->
      <button class="send-button" mat-flat-button type="submit" [color]="'primary'" (click)="save()">
        <span>Run</span>
      </button>
    </div>
  </div>
</form>
